import TeamMemberJoinFailModal from '@/app-shell/modals/team-member-join-fail-modal';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { type PendingTeamJoinPorts } from '@heidi/workspace';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/**
 * The app half of `@heidi/workspace`'s `PendingTeamJoinGate`. Module-scoped, so
 * `_app` adds no hook call; the gate calls each hook member where it used to
 * call the app import, and `useCallback` keeps `replace` stable per router.
 */
export const pendingTeamJoinPorts: PendingTeamJoinPorts = {
  useIsAuthenticated,
  useReplaceRoute: () => {
    const router = useRouter();
    return useCallback(
      (href) => {
        void router.replace(href);
      },
      [router]
    );
  },
  renderJoinFailed: ({ teamId, onReturn }) => (
    <TeamMemberJoinFailModal teamId={teamId} onReturn={onReturn} />
  ),
};
